import React from "react";
import { BulkDeleteButton, Datagrid, EditButton, FunctionField, List, TextField } from "react-admin";
import { SearchableList } from "../SearchableList";
import { UserMember } from "../../types/organizations";

export const ListComponent: React.FC = () => {
  return (
    <List perPage={100}>
      <SearchableList>
      <Datagrid
        rowClick="show"
        bulkActionButtons={<BulkDeleteButton mutationMode="optimistic" />}
        sx={{
          '& tbody tr:nth-of-type(odd)': { backgroundColor: '#1a1a1a' },
          '& tbody tr:nth-of-type(even)': { backgroundColor: '#000000' },
        }}
      >
        <TextField source="first_name" />
        <TextField source="last_name" />
        <TextField source="email" />
        <TextField source="created_at" />
        <FunctionField
          label="Organization"
          sortBy="members.organization.name"
          render={(record: { members?: UserMember[] }) =>
            record.members?.[0]?.organization?.name ?? "-"
          }
        />
        <FunctionField
          label="Level"
          sortBy="members.role"
          render={(record: { members?: UserMember[] }) =>
            record.members?.[0]?.role ?? "-"
          }
        />
        <EditButton />
      </Datagrid>
      </SearchableList>
    </List>
  );
};
